// src/ErrorBoundary.js
import React from "react";
import * as Sentry from "@sentry/react";
import Button from "../_widgets/Button/Button";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false, triedReload: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log to Sentry
    Sentry.captureException(error, { extra: errorInfo });

    // Detect chunk load error
    if (error?.message?.includes("ChunkLoadError")) {
      this.setState({ isChunkError: true }, () => {
        this.tryAutoReload();
      });
    }
  }

  tryAutoReload = () => {
    const alreadyReloaded = sessionStorage.getItem("app-reloaded");

    if (!alreadyReloaded) {
      sessionStorage.setItem("app-reloaded", "true");
      window.location.reload(true); // force reload once
    }
  };

  handleManualReload = () => {
    sessionStorage.removeItem("app-reloaded"); // reset flag for manual reload
    window.location.reload(true);
  };

  render() {
    const { hasError, isChunkError } = this.state;

    if (hasError) {
      return (
        <div
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <img
            src="/BharatOPDLogo.jpeg"
            alt="App Logo"
            style={{
              width: "120px",
              marginBottom: "20px",
            }}
          />

          {isChunkError ? <h2>A new version is available</h2> : <h2>Something went wrong.</h2>}

          <p>Please reload the page to continue.</p>

          <Button
            style={{
              width: "140px",
              marginTop: "20px",
            }}
            onClick={this.handleManualReload}
            text="Reload"
            buttonType="primary"
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
